/* The fixed risk ramp (tokens.css), never remapped per chart. Colour is
 * never the only carrier of state, so the step's name is always in the badge
 * - Kanopy's own word for the band (lib/risk.ts), and the only label a step
 * has. No step is Unmeasured, drawn here in the neutral rather than by each
 * caller, so it reads the same on every screen.
 */
import { readingLabel } from "../api/envelope";
import type { RiskStep, TreeRecord } from "../api/types";
import { bandStep } from "../lib/risk";
import { Badge } from "./Badge";

export function RiskBadge({ step }: { step: RiskStep | null }) {
  const band = step === null ? "unmeasured" : step.toLowerCase();
  return (
    <Badge fill={`risk-fill--${band}`} border={`risk-border--${band}`}>
      {step ?? "Unmeasured"}
    </Badge>
  );
}

/* A tree's band where Kanopy gave one, else what its reading says in its place
 * (15 section 1.4), for a screen that says why a tree has no band rather than
 * leaving it blank. */
export function TreeBandBadge({ tree }: { tree: Pick<TreeRecord, "condition_band" | "assessment"> }) {
  return tree.condition_band !== null ? (
    <RiskBadge step={bandStep(tree.condition_band)} />
  ) : (
    <span className="mono">{readingLabel(tree.assessment)}</span>
  );
}
